export default {
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
};
